module.exports = __webpack_public_path__ + "static/img/36.6eb7081.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/36.jpg
// module id = uvQ7
// module chunks = 1